import { useMemo, useState } from 'react';
import { SliderSingleProps } from 'antd';
import { SliderTrack, Container, Track, TrackWrapper, Wrapper } from './styled';

interface SliderProps extends SliderSingleProps {
  tracksWidth?: number[];
  tracksColor?: string[];
}

const Slider = ({
  tracksWidth = [],
  tracksColor = ['#00AB6B', '#8277F8'],
  defaultValue,
  onChange = () => {},
  ...props
}: SliderProps) => {
  const [clipValue, setClipValue] = useState(defaultValue);
  const isControlled = typeof props.value !== 'undefined';
  const sliderValue = isControlled ? props.value : clipValue;

  const getLimitNumber = (value: number, min = 0, max = 100) =>
    Math.min(Math.max(value, min), max);

  const clipWidth = useMemo(() => {
    const maxSliderValue = props.max || 100;
    const clipPercentage = (sliderValue / maxSliderValue) * 100;

    // Based on 100% css clip-path width - clipPercentage
    const width = 100 - getLimitNumber(clipPercentage);

    return width || 0;
  }, [sliderValue, props.max]);

  const handleValueChange = (value: number) => {
    setClipValue(value);
    onChange(value);
  };

  return (
    <Container>
      <Wrapper>
        <SliderTrack
          onChange={handleValueChange}
          tooltipVisible={false}
          defaultValue={defaultValue}
          {...props}
        />

        <TrackWrapper
          style={{
            clipPath: `polygon(0% 0%, calc(100% - ${clipWidth}%) 0%, calc(100% - ${clipWidth}%) 100%, 0% 100%)`,
          }}
          cutSize={2}
        >
          {tracksWidth.length > 0 ? (
            tracksWidth.map(
              (width, idx) =>
                width > 0 && (
                  <Track
                    key={idx.toString()}
                    width={width}
                    backgroundColor={tracksColor[idx] || '#00AB6B'}
                  />
                ),
            )
          ) : (
            <Track key="tracks" backgroundColor="#00AB6B" />
          )}
        </TrackWrapper>
      </Wrapper>
    </Container>
  );
};

export default Slider;
